const PENDING_PAYMENT_KEY = 'chse_pending_payment';

export function savePendingPayment(payload) {
  try {
    window.sessionStorage.setItem(PENDING_PAYMENT_KEY, JSON.stringify(payload || {}));
  } catch {
    // ignore storage errors
  }
}

export function readPendingPayment() {
  try {
    const raw = window.sessionStorage.getItem(PENDING_PAYMENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearPendingPayment() {
  try {
    window.sessionStorage.removeItem(PENDING_PAYMENT_KEY);
  } catch {
    // ignore storage errors
  }
}
